import { useState, useEffect } from "react";
import { RiUserSettingsFill } from "react-icons/ri";
import { CgProfile } from "react-icons/cg";
import { MdOutlineClose } from "react-icons/md";
import { FiSettings } from "react-icons/fi";
import { AiOutlinePlus } from "react-icons/ai";
import Input from "../../../utils/components/Input";

const WorkflowNode = ({
  stepData,
  users,
  handleActionClick,
  handleRemoveClick,
  handleParallelAddClick,
  handleSerialAddClick,
  handleAutoStepClick,
  handleChangeTitle,
  handleFinishClick,
  handleDuration,
  isEditing,
  isEndNode,
  translate,
}) => {
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [showAddOptions, setShowAddOptions] = useState(false);

  const findUsersById = () => {
    let selectedUsers = [];
    stepData.settings.step_workers.users.forEach((userId) => {
      const user = users.find((user) => user.user_id === userId);
      if (user) {
        selectedUsers.push({
          user_name: user.user_name,
          company_name: user.company_name,
        });
      }
    });
    setSelectedUsers(selectedUsers);
  };

  useEffect(() => {
    findUsersById();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stepData, users, isEditing]);

  return (
    <div className="card shadow">
      {isEditing && (
        <span
          className="parallel-add-node p-2 rounded-circle"
          onClick={handleParallelAddClick}
        >
          <AiOutlinePlus className="fs-5 text-white" />
        </span>
      )}
      {isEditing && (
        <span className="serial-add-node d-flex flex-row align-items-start justify-content-center">
          <span
            className="icon rounded-circle p-2 mt-1"
            onClick={() => setShowAddOptions(!showAddOptions)}
          >
            <AiOutlinePlus className="fs-5 text-white" />
          </span>
          {showAddOptions && (
            <div className="addOptions d-flex flex-column ms-3">
              <span
                className="addSerialOption fs-4 fw-semibold text-orange mt-1"
                onClick={() => {
                  setShowAddOptions(false);
                  handleSerialAddClick();
                }}
              >
                {translate("design_approval_process.nodes.manual")}
              </span>
              {/*               <span
                className="addAutoOption fs-4 fw-semibold text-orange my-2"
                onClick={() => {
                  setShowAddOptions(false);
                  handleAutoStepClick();
                }}
              >
                Automatic
              </span> */}
              {isEndNode && (
                <span
                  className="addFinishOption fs-4 fw-semibold text-orange"
                  onClick={() => {
                    setShowAddOptions(false);
                    handleFinishClick();
                  }}
                >
                  {translate("design_approval_process.nodes.ending")}
                </span>
              )}
            </div>
          )}
        </span>
      )}
      <div className="card-header d-flex flex-wrap align-items-center justify-content-between py-3">
        <div className="d-flex align-items-center">
          <RiUserSettingsFill className="fs-2 me-2" />
          {isEditing ? (
            <Input
              type="text"
              className="form-control"
              placeholder={translate(
                "design_approval_process.nodes.enter-title"
              )}
              defaultValue={stepData.name || ""}
              onChange={handleChangeTitle}
            />
          ) : (
            <p className="fs-5 mb-0 ms-2">{stepData.name}</p>
          )}
        </div>
        {isEditing && (
          <FiSettings
            className="fs-2 ml-2 cursor--pointer"
            onClick={handleActionClick}
          />
        )}
      </div>
      <div className="card-body">
        <div>
          {selectedUsers.map((user, index) => (
            <div
              className="d-flex flex-wrap align-items-center justify-content-between my-2"
              key={index}
            >
              <div className="d-flex align-items-center">
                <CgProfile className="fs-3" />
                <p className="mb-0 ms-2">{user.user_name}</p>
              </div>
              <p className="mb-0 ms-2">{user.company_name}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="card-footer d-flex align-items-center bg-white py-3 border-gray">
        <p className="mb-0 fs-5">
          {translate("design_approval_process.nodes.duration") + ":"}
        </p>
        <div className="duration col-md-5 col-lg-4 d-flex align-items-center ms-4">
          {isEditing ? (
            <Input
              placeholder={translate("design_approval_process.nodes.duration")}
              type="number"
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) event.preventDefault();
              }}
              onChange={handleDuration}
              value={stepData.duration}
              inputProps={{
                min: 1,
              }}
            />
          ) : (
            <p className="mb-0 ps-2 fs-5">{stepData.duration}</p>
          )}
          <p className="mb-0 ps-2 fs-5">
            {translate("design_approval_process.nodes.day")}
          </p>
        </div>
        {isEditing && (
          <MdOutlineClose
            className="fs-1 text-orange ml-2 ms-auto"
            onClick={handleRemoveClick}
          />
        )}
      </div>
    </div>
  );
};
export default WorkflowNode;
